import styled from "styled-components";

export const FormContainer = styled.div`
  padding: 32px 0;
  margin-bottom: 32px;
  .prev {
    margin-top: -92px;
    padding-right: 12px;
  }
  @media only screen and (max-width: 760px) {
    .prev {
      margin-top: -88px;
    }
  }
`;
